"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgClip = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M16.301 12.573a1 1 0 01-1.414 1.414L11.39 10.49c-1.075-1.075-1.762-1.14-2.526-.377-.768.768-.703 1.456.373 2.53l5.614 5.615c1.509 1.485 2.774 1.478 4.275-.022 1.499-1.499 1.5-2.753.006-4.247L12.073 6.93c-2.457-2.462-4.545-2.552-6.745-.352s-2.11 4.288.352 6.746l4.936 4.936a1 1 0 11-1.414 1.414l-4.935-4.935C1.048 11.525.903 8.173 3.913 5.163c3.01-3.01 6.362-2.865 9.574.353l7.058 7.058c2.276 2.276 2.273 4.796-.006 7.075-2.276 2.277-4.8 2.289-7.097.028l-5.62-5.62c-1.804-1.803-1.987-3.745-.374-5.359C9.06 7.086 11 7.272 12.803 9.075l3.498 3.498z' }))); };
exports.default = SvgClip;
//# sourceMappingURL=Clip.js.map